import type { ReactNode } from 'react'

import type { Status } from './tokens'
import { Text } from './Text'
import './system.css'

export function Alert({
  status,
  title,
  action,
  children,
}: {
  status?: Status | undefined
  title: string
  action?: { label: string; onClick: () => void } | undefined
  children?: ReactNode
}) {
  return (
    <div
      className={status ? `alert alert--${status}` : 'alert'}
      role={status === 'danger' ? 'alert' : 'status'}
    >
      <Text role="body-strong" className="alert__title">
        {title}
      </Text>
      {children}
      {action ? (
        <button className="alert__action" type="button" onClick={action.onClick}>
          {action.label}
        </button>
      ) : null}
    </div>
  )
}
